import React, { ComponentClass, FunctionComponent } from 'react';
import {
  Link as MuiLink, styled, Theme, useMediaQuery,
} from '@mui/material';
import Logomark from '../icons/Logomark';
import { Typography } from '../typography';

export const HomeLinkLabel = styled(Typography)(({ theme }) => ({
  paddingBottom: 3,
  ...theme.typography.subtitle1,
}));

export const HomeLinkWrapper = styled('div')(() => ({
  height: '100%',
  alignItems: 'center',
}));

export const HomeLinkAnchor = styled(MuiLink)(({ theme }) => ({
  color: theme.palette.secondary.main,
  textDecoration: 'none',
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
}));

interface Props<TIconProps extends object> extends React.HTMLAttributes<HTMLDivElement> {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  Icon: FunctionComponent<TIconProps> | ComponentClass<TIconProps, any>;
  IconProps: TIconProps,
  label: string;
  href: string;
}

/* eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len */
export type HomeLinkProps<TIconProps extends object = any> = DefaultProps<TIconProps> & Props<TIconProps>;

type DefaultProps<TIconProps extends object = Record<string, unknown>> = {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  Icon: FunctionComponent<TIconProps> | ComponentClass<TIconProps, any>;
  IconProps: TIconProps;
  label: string;
  href: string;
};

const defaultProps: DefaultProps = {
  Icon: Logomark,
  IconProps: {},
  label: 'Chemaxon',
  href: '/',
};

function HomeLink({
  Icon, IconProps, href, label, ...props
}: HomeLinkProps) {
  const mdUp = useMediaQuery<Theme>((theme) => theme.breakpoints.up('md'));

  return (
    <HomeLinkWrapper {...props}>
      <HomeLinkAnchor href={href}>
        <Icon {...IconProps} />
        {' '}
        {mdUp && <HomeLinkLabel>{label}</HomeLinkLabel>}
      </HomeLinkAnchor>
    </HomeLinkWrapper>
  );
}

HomeLink.defaultProps = defaultProps;

export default React.memo(HomeLink);
